import {
  GAME_ID,
  REDUX_ACTIONS,
  SCREENS,
} from '../../data/constants';

const initialState = {
  // list of questions
  questions: [],
  // level id round belongs to
  levelId: null,
  // current question index
  currentQuestionIndex: null,
  correctAnswerCount: 0,
  // last played story
  lastPlayedStory: {},
};

const roundReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.CHANGE_SCREEN: {
      if (action.payload === SCREENS.PROGRESS) {
        return {
          ...state,
          lastPlayedStory: {},
        };
      }
      return state;
    }

    case REDUX_ACTIONS.INIT_ROUND: {
      const { questions, levelId } = action.payload;

      return {
        ...initialState,
        questions,
        levelId,
        currentQuestionIndex: 0,
        lastPlayedStory: state.lastPlayedStory,
      };
    }
    case REDUX_ACTIONS.SET_QUESTION: {
      const { questionIndex } = action.payload;

      return {
        ...state,
        currentQuestionIndex: questionIndex || 0,
      };
    }
    case REDUX_ACTIONS.INCREMENT_CORRECT_ANSWER_COUNT: {
      return {
        ...state,
        correctAnswerCount: state.correctAnswerCount + 1,
      };
    }
    case REDUX_ACTIONS.PUBLISH_STORY: {
      const questions = state.questions.map((question, index) => ({
        ...question,
        isPublished: state.currentQuestionIndex === index ? true : question.isPublished,
      }));
      return {
        ...state,
        questions,
      };
    }
    case REDUX_ACTIONS.SET_LAST_PLAYED_STORY: {
      const { story } = action.payload;

      return {
        ...state,
        lastPlayedStory: story,
      };
    }
    case REDUX_ACTIONS.QUICK_ROUND: {
      const { shouldPassLevel } = action.payload;

      return {
        ...state,
        correctAnswerCount: shouldPassLevel ? state.questions.length : 0,
      };
    }

    default:
      return state;
  }
};

export default roundReducer;
